module.exports = __webpack_public_path__ + "static/media/ic_edit.5e27c1c8.svg";